import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToTimeHm',
})
export class DateToTimeHmPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return formatDate(value, 'H:m', 'en');
  }
}
